var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.to.startsWith('http'))?_c('div',[_c('a',{staticClass:"bounce-right slide-button",attrs:{"href":_vm.to,"target":"_blank"}},[_vm._t("default")],2)]):_c('div',[_c('router-link',{staticClass:"bounce-right slide-button",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }